module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal custom-modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask modal-lg"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "width": "initial"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-info-circle"
  }), _vm._v(" Policy #" + _vm._s(_vm.policy.policy_number) + " "), _c('small', [_vm._v("[" + _vm._s(_vm.policy.id) + "]")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body pre-scrollable",
    style: ({
      'max-height': _vm.bodyHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "lead-detail"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Details")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Type")]), _c('td', [_vm._v(_vm._s(_vm.policy.policy_type_code))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Description")]), _c('td', [_vm._v(_vm._s(_vm.policy.description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Effective Date")]), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.policy.effective_date)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Expiration Date")]), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.policy.expiration_date)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Client")]), _c('td', [_vm._v("(" + _vm._s(_vm.policy.client.client_id) + ") [" + _vm._s(_vm.policy.client.client_lookup_code) + "] " + _vm._s(_vm.policy.client.account_name))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 bg-dark lead-data"
  }, [_c('h4', [_vm._v("IDs")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Policy Number")]), _c('td', [_vm._v(_vm._s(_vm.policy.policy_number))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Policy ID")]), _c('td', [_vm._v(_vm._s(_vm.policy.policy_id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Original Policy ID")]), _c('td', [_vm._v(_vm._s(_vm.policy.original_policy_id))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Branch & Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Branch")]), _c('td', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.policy.branch_code.code))]), _vm._v(" " + _vm._s(_vm.policy.branch_code.description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Source")]), _c('td', [_vm._v(_vm._s(_vm.policy.source))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Premiums")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Billed")]), _c('td', [_vm._v("$" + _vm._s(_vm.policy.billed_premium))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Estimated")]), _c('td', [_vm._v("$" + _vm._s(_vm.policy.estimated_premium))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Annualized")]), _c('td', [_vm._v("$" + _vm._s(_vm.policy.annualized_premium))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Downloaded")]), _c('td', [_vm._v("$" + _vm._s(_vm.policy.downloaded))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Commissions")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Billed")]), _c('td', [_vm._v("$" + _vm._s(_vm.policy.billed_commission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Estimated")]), _c('td', [_vm._v("$" + _vm._s(_vm.policy.estimated_commission))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Annualized")]), _c('td', [_vm._v("$" + _vm._s(_vm.policy.annualized_commission))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 bg-dark lead-data"
  }, [_c('h4', [_vm._v("Lines")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 fields-list-wrapper"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Line ID")]), _vm._v(" "), _c('th', [_vm._v("Timestamp")]), _vm._v(" "), _c('th', [_vm._v("Type Code")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Issuing Company")]), _vm._v(" "), _c('th', [_vm._v("Billed Premium")]), _vm._v(" "), _c('th', [_vm._v("Estimated Premium")]), _vm._v(" "), _c('th', [_vm._v("Annualized Premium")]), _vm._v(" "), _c('th', [_vm._v("Downloaded Premium")]), _vm._v(" "), _c('th', [_vm._v("Billed Commission")]), _vm._v(" "), _c('th', [_vm._v("Estimated Commission")]), _vm._v(" "), _c('th', [_vm._v("Annualized Commission")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.policy.lines), function(line) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(line.line_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatTimestamp")(line.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.line_type_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.line_type_description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.status_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.issuing_company_lookup_code))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(line.billed_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(line.estimated_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(line.annualized_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(line.downloaded_premium))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(line.billed_commission))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(line.estimated_commission))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(line.annualized_commission))])])
  }), 0)])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b7ed1a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PolicyModal.vue
// module id = 658
// module chunks = 0